/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import axios from 'axios';
import React, { useEffect, useState, useContext } from 'react';
import { Col, Row, Image, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { SpinnerDotted } from 'spinners-react';
import { toast } from 'react-toastify';
import { getCookies } from '../../hooks/useCookies';
import { TableContext } from '../../contexts/tableContext';
import styles from './viewUser.module.scss';
import envValues from '../../enviornment';
import defaultImage from '../../assets/avatar.png';
import DeleteModal from '../../components/DeleteModal/DeleteModal';
import ResetPasswordModal from '../../components/NewModals/ResetPasswordModal/ResetPasswordModal';
import SuspendUserModal from '../../components/NewModals/SuspendUserModal/SuspendUserModal';
import { getImageUrl } from '../../utilityFunctions/utilsFunctions';

function ViewUsers() {
  let userId;
  let statusCode;

  const params = useParams();
  const navigate = useNavigate();

  const token = `Bearer ${getCookies('Token')}`;

  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { viewformStyle } = useContext(TableContext);

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getUserDetails = async () => {
    setLoading(true);
    await axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/user/app/${userId}`, {
        method: 'GET',
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          setDetails(res.data.appUser);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  // DELETE MODAL FUNCTIONS -------------------------------------
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    const appUserId = details?.id || details?._id;
    try {
      await axios
        .delete(`${envValues.REACT_APP_API_ENDPOINT}/user/${appUserId}`)
        .then((response) => {
          if (response.data?.success) {
            toast.success('User deleted successfully.');
            navigate(-1);
          }
        });
    } catch (error) {
      toast.error('Failed to delete user.');
    }
  };

  const handleResetPasswordClose = () => {
    setShowResetPasswordModal(false);
  };

  const confirmResetPassword = async (newPassword) => {
    const appUserId = details?.id || details?._id;

    try {
      await axios
        .patch(`${envValues.REACT_APP_API_ENDPOINT}/auth/appuser/reset-password/${appUserId}`, {
          password: newPassword,
        })
        .then((response) => {
          if (response.data?.success) {
            toast.success('Password reset successfully.');
            setShowResetPasswordModal(false);
          }
        });
    } catch (error) {
      toast.error('Failed to reset password.');
    }
  };

  const handleSuspendModalClose = () => {
    setShowSuspendModal(false);
  };

  const confirmSuspendUser = async (reason, description) => {
    const appUserId = details?.id || details?._id;

    try {
      await axios
        .patch(`${envValues.REACT_APP_API_ENDPOINT}/auth/appuser/suspend/${appUserId}`, {
          reason,
          description,
        })
        .then((response) => {
          if (response.data?.success) {
            toast.success('User suspended successfully.');
            setShowSuspendModal(false);
          }
        });
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error('User is already suspended.');
      } else {
        toast.error('Failed to suspend user.');
      }
    } finally {
      userId = params.userId;
      getUserDetails();
    }
  };

  // CONTEXT MENU FUNCTIONS -------------------------------------
  const handleContextMenuToggle = () => {
    setShowContextMenu(!showContextMenu);
  };

  const handleContextMenuClose = () => {
    setShowContextMenu(false);
  };

  const handleCollaborationHistory = () => {
    navigate(`/user/collaboration-history/${params.userId}`);
    handleContextMenuClose();
  };

  const handleContentPosts = () => {
    navigate(`/user/content-posts/${params.userId}`);
    handleContextMenuClose();
  };

  const handleResetPassword = () => {
    setShowResetPasswordModal(true);
    handleContextMenuClose();
  };

  const handleSuspendUser = () => {
    setShowSuspendModal(true);
    handleContextMenuClose();
  };

  const handleReactivateUser = async () => {
    const appUserId = details?.id || details?._id;
    if (!appUserId) {
      toast.error('User ID not found');
      return;
    }

    try {
      const headers = {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
      };
      const body = { token: getCookies('Token'), userid: appUserId, active: true };
      await axios.post(`${envValues.REACT_APP_API_ENDPOINT}/auth/toggle-change`, body, headers);
      toast.success('User reactivated successfully.');
      handleContextMenuClose();
      userId = params.userId;
      getUserDetails();
    } catch (error) {
      toast.error('Failed to reactivate user.');
    }
  };

  const handleDeleteAccount = () => {
    setShowDeleteModal(true);
    handleContextMenuClose();
  };

  const handleClickOutside = (event) => {
    if (showContextMenu && !event.target.closest('.context-menu-container')) {
      handleContextMenuClose();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    userId = params.userId;
    getUserDetails();
    setDashboardHeader('User Details');
  }, []);

  useEffect(() => {
    if (showContextMenu) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showContextMenu]);

  return (
    <>
      <div className={styles[bodyStyle]}>
        <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
          <div className="form_head">
            <div
              value="Back"
              onClick={() => {
                navigate(-1);
              }}
              className={`${styles.arrowback} backBtn`}
            >
              <svg
                className="mr-1"
                width="17"
                height="14"
                viewBox="0 0 17 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 6.00003H3.64L7.27 1.64003C7.43974 1.43581 7.5214 1.17253 7.49702 0.908108C7.47264 0.643682 7.34422 0.39977 7.14 0.230032C6.93578 0.060293 6.6725 -0.0213689 6.40808 0.0030108C6.14365 0.0273905 5.89974 0.155815 5.73 0.360032L0.73 6.36003C0.696361 6.40776 0.666279 6.45789 0.64 6.51003C0.64 6.56003 0.64 6.59003 0.57 6.64003C0.524674 6.75469 0.500941 6.87674 0.5 7.00003C0.500941 7.12332 0.524674 7.24537 0.57 7.36003C0.57 7.41003 0.57 7.44003 0.64 7.49003C0.666279 7.54217 0.696361 7.59231 0.73 7.64003L5.73 13.64C5.82402 13.7529 5.94176 13.8437 6.07485 13.9059C6.20793 13.9681 6.35309 14.0003 6.5 14C6.73365 14.0005 6.96009 13.9191 7.14 13.77C7.24126 13.6861 7.32496 13.583 7.38631 13.4666C7.44766 13.3503 7.48546 13.223 7.49754 13.092C7.50961 12.961 7.49573 12.829 7.45669 12.7034C7.41764 12.5777 7.3542 12.4611 7.27 12.36L3.64 8.00003H15.5C15.7652 8.00003 16.0196 7.89467 16.2071 7.70714C16.3946 7.5196 16.5 7.26525 16.5 7.00003C16.5 6.73482 16.3946 6.48046 16.2071 6.29292C16.0196 6.10539 15.7652 6.00003 15.5 6.00003Z"
                  fill=""
                />
              </svg>
              Back
            </div>

            {/* CONTEXT MENU BUTTON */}
            <div className={styles.btn_contain}>
              <div className={styles.action_btns}>
                <div className="context-menu-container" style={{ position: 'relative' }}>
                  <Button className={`${styles.deleteBtn}`} onClick={handleContextMenuToggle}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 1.5C9.82843 1.5 10.5 2.17157 10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5Z"
                        fill="white"
                      />
                      <path
                        d="M9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5Z"
                        fill="white"
                      />
                      <path
                        d="M9 13.5C9.82843 13.5 10.5 14.1716 10.5 15C10.5 15.8284 9.82843 16.5 9 16.5C8.17157 16.5 7.5 15.8284 7.5 15C7.5 14.1716 8.17157 13.5 9 13.5Z"
                        fill="white"
                      />
                    </svg>
                    Actions
                  </Button>

                  {/* CONTEXT MENU */}
                  {showContextMenu && (
                    <div
                      className="context-menu"
                      style={{
                        position: 'absolute',
                        top: '100%',
                        right: '0',
                        backgroundColor: 'white',
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        boxShadow:
                          '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                        zIndex: 1000,
                        minWidth: '200px',
                        padding: '8px 0',
                      }}
                    >
                      {/* COLLAB HISTORY BUTTON */}
                      <button
                        type="button"
                        onClick={handleCollaborationHistory}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: 'none',
                          backgroundColor: 'transparent',
                          textAlign: 'left',
                          cursor: 'pointer',
                          fontSize: '14px',
                          color: '#374151',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#f3f4f6';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                            fill="#6b7280"
                          />
                          <path
                            d="M8 4c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"
                            fill="#6b7280"
                          />
                          <path
                            d="M8 10c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                            fill="#6b7280"
                          />
                        </svg>
                        Collaboration History
                      </button>

                      {/* CONTENT POSTS BUTTON */}
                      <button
                        type="button"
                        onClick={handleContentPosts}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: 'none',
                          backgroundColor: 'transparent',
                          textAlign: 'left',
                          cursor: 'pointer',
                          fontSize: '14px',
                          color: '#374151',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#f3f4f6';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 2H2c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM2 1h12c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
                            fill="#6b7280"
                          />
                          <path d="M4 5h8v1H4V5zm0 2h8v1H4V7zm0 2h5v1H4V9z" fill="#6b7280" />
                        </svg>
                        Content Posts
                      </button>

                      {/* RESET PASSWORD BUTTON */}
                      {details?.authMethod === 'email' && (
                        <button
                          type="button"
                          onClick={handleResetPassword}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: 'none',
                            backgroundColor: 'transparent',
                            textAlign: 'left',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#374151',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f3f4f6';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                              fill="#6b7280"
                            />
                            <path
                              d="M8 4c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"
                              fill="#6b7280"
                            />
                            <path
                              d="M8 10c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                              fill="#6b7280"
                            />
                          </svg>
                          Reset Password
                        </button>
                      )}

                      {/* SUSPEND/REACTIVATE USER BUTTON */}
                      {details.active ? (
                        <button
                          type="button"
                          onClick={handleSuspendUser}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: 'none',
                            backgroundColor: 'transparent',
                            textAlign: 'left',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#f59e0b', // choose a warning color like amber
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#fffbeb';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                              fill="#f59e0b"
                            />
                            <path
                              d="M8 4v4l2 2"
                              stroke="#f59e0b"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Suspend User
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={handleReactivateUser}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: 'none',
                            backgroundColor: 'transparent',
                            textAlign: 'left',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#10b981', // green color for reactivate
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#ecfdf5';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                              fill="#10b981"
                            />
                            <path
                              d="M11 5L6 10L5 9"
                              stroke="#10b981"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Reactivate User
                        </button>
                      )}

                      <div style={{ borderTop: '1px solid #e5e7eb', margin: '4px 0' }} />

                      {/* DELETE ACCOUNT BUTTON */}
                      <button
                        type="button"
                        onClick={handleDeleteAccount}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: 'none',
                          backgroundColor: 'transparent',
                          textAlign: 'left',
                          cursor: 'pointer',
                          fontSize: '14px',
                          color: '#dc2626',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#fef2f2';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.25 4.25L3.1875 19.25C3.23203 20.1167 3.8625 20.75 4.6875 20.75H13.3125C14.1408 20.75 14.7595 20.1167 14.8125 19.25L15.75 4.25"
                            stroke="#dc2626"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path d="M0.75 4.25H17.25H0.75Z" fill="black" />
                          <path
                            d="M0.75 4.25H17.25"
                            stroke="#dc2626"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                          />
                          <path
                            d="M6 4.25V2.375C5.99957 2.22715 6.02837 2.08066 6.08475 1.94397C6.14114 1.80729 6.22399 1.6831 6.32854 1.57854C6.43309 1.47399 6.55728 1.39114 6.69397 1.33476C6.83066 1.27838 6.97714 1.24957 7.125 1.25H10.875C11.0229 1.24957 11.1693 1.27838 11.306 1.33476C11.4427 1.39114 11.5669 1.47399 11.6715 1.57854C11.776 1.6831 11.8589 1.80729 11.9152 1.94397C11.9716 2.08066 12.0004 2.22715 12 2.375V4.25M9 7.25001V17.75M5.625 7.25001L6 17.75M12.375 7.25001L12 17.75"
                            stroke="#dc2626"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        Delete Account
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${styles[formthemeStyle]} ${styles.profile_view_container} profile_view_container`}
            id={styles.addform}
          >
            {loading ? (
              <SpinnerDotted
                style={{
                  color: '#39979d',
                  left: '50%',
                  position: 'relative',
                  textAlign: 'center',
                  top: '50%',
                }}
              />
            ) : (
              <Row>
                <Col lg={3}>
                  <div className={styles.profilepicdiv}>
                    <Image
                      src={details.image ? getImageUrl(details.image) : defaultImage}
                      alt="logo"
                      className={styles.profilepic}
                    />
                  </div>
                </Col>

                <Col lg={3}>
                  <span className={styles.title}>Name</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>
                      {' '}
                      {details.firstName || details.lastName
                        ? `${details.firstName ?? ''} ${details.lastName ?? ''}`.trim()
                        : 'NA'}
                    </p>
                  </div>

                  <span className={styles.title}>Title</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.title ?? 'NA'}</p>
                  </div>

                  <span className={styles.title}>Verified</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.isVerified ? 'Yes' : 'No'}</p>
                  </div>

                  <span className={styles.title}>Location</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.userLocation ?? 'NA'}</p>
                  </div>
                </Col>

                <Col lg={3}>
                  <span className={styles.title}>Email</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.email ?? 'NA'}</p>
                  </div>

                  <span className={styles.title}>Status</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.active ? 'Active' : 'Inactive'}</p>
                  </div>

                  <span className={styles.title}>Phone Number</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.phone ?? 'NA'}</p>
                  </div>

                  <span className={styles.title}>Interested In</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>
                      {details.interestedIn?.length
                        ? details.interestedIn?.map((item) => item.label).join(', ')
                        : 'Nothing yet'}
                    </p>
                  </div>
                </Col>

                <Col lg={3}>
                  <span className={styles.title}>Account Type</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>
                      {details.authMethod
                        ? details.authMethod.charAt(0).toUpperCase() + details.authMethod.slice(1)
                        : 'NA'}
                    </p>
                  </div>

                  <span className={styles.title}>Bio</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.bio ?? 'NA'}</p>
                  </div>

                  <span className={styles.title}>Connection Count</span>
                  <div className={styles[viewformStyle]} id={styles.empdiv}>
                    <p className={styles.empname}>{details.connectionCount ?? '0'}</p>
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>

      <DeleteModal
        show={showDeleteModal}
        context="user"
        handleClose={handleDeleteClose}
        onConfirm={confirmDelete}
        onCancel={handleDeleteClose}
      />

      <ResetPasswordModal
        show={showResetPasswordModal}
        context="user"
        handleClose={handleResetPasswordClose}
        onConfirm={confirmResetPassword}
        onCancel={handleResetPasswordClose}
      />

      <SuspendUserModal
        show={showSuspendModal}
        context="user"
        handleClose={handleSuspendModalClose}
        onConfirm={confirmSuspendUser}
        onCancel={handleSuspendModalClose}
      />
    </>
  );
}

export default ViewUsers;
